import React from 'react';
import { Route } from 'react-router-dom';
import UserProfile from './userProfile/userProfile';

const app = [
    <Route exact path="/profile" component={UserProfile} />,
];

export default app;